module.exports = __webpack_public_path__ + "v4assets/perf-monitor-interconnects-dark.1b27be987c15175ff658b46eac3826b3.png";